/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".addSupplierDialogBox[_ngcontent-%COMP%]{border:thin dotted #efefef;padding:4px}.addSupplierDialogTable[_ngcontent-%COMP%]{overflow-y:auto;max-height:250px}"];
export { styles as styles };
